import {action, makeObservable, observable, toJS} from 'mobx';

class EndpointGroup {
  @observable id = null;
  @observable tags = [];
  @observable label: string | null = null;
  @observable index: 0 | 1 = 0;

  @action
  setLabel(label: string) {
    this.label = label || null;
  }

  constructor({id = null, label = null, tags = []}, index: 0 | 1) {
    this.id = id;
    this.label = label;
    this.tags = tags;
    this.index = index;
    makeObservable(this);
  }

  static deserialize(jsonValue) {
    return new EndpointGroup(jsonValue, jsonValue.index);
  }

  serialize() {
    return toJS({
      id: this.id,
      label: this.label,
      tags: this.tags,
      index: this.index
    });
  }
}

export default EndpointGroup;
